import React, { useState, useEffect } from 'react';
import { Gift, Users, Save, DollarSign, Plus, Trash2, Image, Share2 } from 'lucide-react';
import { API_URL } from '../../config';
import { toast } from 'sonner';

export default function BonusLinksManagement() {
  const [packages, setPackages] = useState([]);
  const [bonusSettings, setBonusSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  
  const [form, setForm] = useState({
    referrer_bonus_per_package: {},  // DEPRECATED
    referrer_bonus_images_per_package: {},  // DEPRECATED
    referrer_bonus_image_tiers: [],  // NEU: Staffel-System
    welcome_bonus_images_registration: 0,  // Bilder bei Registrierung
    welcome_bonus_images_first_purchase: 0,  // Bilder beim ersten Kauf
    welcome_bonus_snaps_registration: 0,  // SNAPs bei Registrierung
    welcome_bonus_registration: 0,  // DEPRECATED
    welcome_bonus_first_purchase: 0,  // DEPRECATED
    referral_share_text: 'Erstelle deine eigenen KI-Avatare mit SNAPSHOT! 🎨\n\nA product of snapshotpro.ai',
    video_share_text: 'Mein KI-Video — Erstellt mit SnapshotPro.ai',
    photo_share_text: 'Mein KI-Foto — Erstellt mit SnapshotPro.ai'
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const adminToken = localStorage.getItem('snapshot_token');
      
      // Fetch packages
      const pkgRes = await fetch(`${API_URL}/api/pricing/admin/packages`, {
        headers: { 'Authorization': `Bearer ${adminToken}` }
      });
      const pkgData = await pkgRes.json();
      setPackages(pkgData.packages || []);
      
      // Fetch bonus settings
      const bonusRes = await fetch(`${API_URL}/api/referral/admin/bonus-settings`, {
        headers: { 'Authorization': `Bearer ${adminToken}` }
      });
      const bonusData = await bonusRes.json();
      setBonusSettings(bonusData);
      setForm(bonusData);
      
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Fehler beim Laden der Daten');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const adminToken = localStorage.getItem('snapshot_token');
      
      const res = await fetch(`${API_URL}/api/referral/admin/bonus-settings`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${adminToken}`
        },
        body: JSON.stringify(form)
      });
      
      if (res.ok) {
        const data = await res.json();
        setBonusSettings(data.settings);
        setEditing(false);
        toast.success('Bonus-Einstellungen gespeichert!');
      } else {
        throw new Error('Save failed');
      }
    } catch (error) {
      console.error('Error saving:', error);
      toast.error('Fehler beim Speichern');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setForm(bonusSettings);
    setEditing(false);
  };

  const updatePackageBonus = (packageId, bonus) => {
    const newBonuses = { ...form.referrer_bonus_per_package };
    newBonuses[packageId] = parseFloat(bonus) || 0;
    setForm({ ...form, referrer_bonus_per_package: newBonuses });
  };
  
  const updatePackageBonusImages = (packageId, images) => {
    const newBonuses = { ...form.referrer_bonus_images_per_package };
    newBonuses[packageId] = parseInt(images) || 0;
    setForm({ ...form, referrer_bonus_images_per_package: newBonuses });
  };
  
  const addTier = () => {
    const newTiers = [...(form.referrer_bonus_image_tiers || [])];
    newTiers.push({
      min_eur: 10,
      max_eur: 19.99,
      images: 5,
      description: "Neue Staffel"
    });
    setForm({ ...form, referrer_bonus_image_tiers: newTiers });
  };
  
  const updateTier = (index, field, value) => {
    const newTiers = [...form.referrer_bonus_image_tiers];
    
    if (field === 'description') {
      newTiers[index][field] = value;  // Text bleibt Text
    } else if (field === 'images') {
      newTiers[index][field] = parseInt(value) || 0;
    } else {
      newTiers[index][field] = parseFloat(value) || 0;  // min, max
    }
    
    setForm({ ...form, referrer_bonus_image_tiers: newTiers });
  };
  
  const deleteTier = (index) => {
    const newTiers = form.referrer_bonus_image_tiers.filter((_, i) => i !== index);
    setForm({ ...form, referrer_bonus_image_tiers: newTiers });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <p>Lade Bonus-Einstellungen...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white p-8">
      <div className="max-w-6xl mx-auto">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-4xl font-bold mb-2 flex items-center gap-3">
              <Gift className="w-10 h-10 text-[#10B981]" />
              Bonus & Links
            </h1>
            <p className="text-white/60">Verwalte Referral-Boni und Willkommens-Boni</p>
          </div>
          
          {!editing ? (
            <button
              onClick={() => setEditing(true)}
              className="px-4 py-2 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-all"
            >
              Bearbeiten
            </button>
          ) : null}
        </div>

        {/* ALTE SECTIONS WURDEN ENTFERNT - Jetzt Staffel-System */}

        {/* BEREICH 2: REFERRAL SHARE-TEXT */}
        <div className="mb-8 p-6 bg-white/5 rounded-xl border border-white/10">
          <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
            <svg className="w-6 h-6 text-[#10B981]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
            Referral Share-Text
          </h2>
          <p className="text-sm text-white/60 mb-6">
            Dieser Text wird verwendet, wenn User ihren Referral-Link teilen (WhatsApp, Telegram).
          </p>
          
          <div className="p-4 bg-black/40 rounded-lg border border-white/10">
            <label className="text-sm font-bold text-white block mb-2">
              Share-Nachricht
            </label>
            <textarea
              value={form.referral_share_text || 'Erstelle deine eigenen KI-Avatare mit SNAPSHOT! 🎨\n\nA product of snapshotpro.ai'}
              onChange={(e) => setForm({...form, referral_share_text: e.target.value})}
              disabled={!editing}
              rows={4}
              className="w-full px-4 py-3 bg-black/60 border-2 border-white/20 rounded-xl text-white text-sm disabled:opacity-50 focus:border-[#10B981] transition-all resize-none"
              placeholder="Erstelle deine eigenen KI-Avatare mit SNAPSHOT! 🎨..."
            />
            <p className="text-xs text-white/40 mt-2">
              💡 Der Referral-Link wird automatisch am Ende angefügt
            </p>
            <p className="text-xs text-white/40 mt-1">
              Platzhalter: {'{LINK}'} wird ersetzt durch den echten Link
            </p>
          </div>
        </div>

        {/* BEREICH 3: SHARE-TEXTE FÜR FOTOS & VIDEOS */}
        <div className="mb-8 p-6 bg-white/5 rounded-xl border border-white/10">
          <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
            <Share2 className="w-6 h-6 text-[#10B981]" />
            Share-Texte (Fotos & Videos)
          </h2>
          <p className="text-sm text-white/60 mb-6">
            Diese Texte werden verwendet, wenn User Fotos oder Videos über die Share-Funktion teilen.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Video Share */}
            <div className="p-4 bg-black/40 rounded-lg border border-white/10">
              <h3 className="text-sm font-bold text-white mb-3">Video-Share</h3>
              <p className="text-xs text-white/40 mb-2">Wird als Titel (File-Share) oder Text (URL-Share) verwendet</p>
              <textarea
                value={form.video_share_text || ''}
                onChange={(e) => setForm({...form, video_share_text: e.target.value})}
                disabled={!editing}
                rows={3}
                className="w-full px-4 py-2 bg-black/60 border-2 border-white/20 rounded-xl text-white text-sm disabled:opacity-50 focus:border-[#10B981] transition-all resize-none"
                placeholder="Mein KI-Video — Erstellt mit SnapshotPro.ai"
              />
            </div>

            {/* Foto Share */}
            <div className="p-4 bg-black/40 rounded-lg border border-white/10">
              <h3 className="text-sm font-bold text-white mb-3">Foto-Share</h3>
              <p className="text-xs text-white/40 mb-2">Wird als Titel (File-Share) oder Text (URL-Share) verwendet</p>
              <textarea
                value={form.photo_share_text || ''}
                onChange={(e) => setForm({...form, photo_share_text: e.target.value})}
                disabled={!editing}
                rows={3}
                className="w-full px-4 py-2 bg-black/60 border-2 border-white/20 rounded-xl text-white text-sm disabled:opacity-50 focus:border-[#10B981] transition-all resize-none"
                placeholder="Mein KI-Foto — Erstellt mit SnapshotPro.ai"
              />
            </div>
          </div>
        </div>

        {/* BEREICH 4: WILLKOMMENS-BONUS - NUR BILDER */}
        <div className="mb-8 p-6 bg-emerald-500/5 rounded-xl border border-emerald-500/20">
          <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
            <Gift className="w-6 h-6 text-emerald-400" />
            Willkommens-Bonus: Kostenlose Bilder
          </h2>
          <p className="text-sm text-emerald-300/80 mb-6">
            Diese kostenlosen BILDER erhalten neue User als Startguthaben (keine SNAPs).
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 bg-black/40 rounded-lg border border-emerald-500/20">
              <label className="text-sm font-bold text-white block mb-2">
                Bei Registrierung (sofort)
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  step="1"
                  min="0"
                  inputMode="numeric"
                  value={form.welcome_bonus_images_registration ?? ''}
                  onChange={(e) => {
                    const val = e.target.value === '' ? 0 : parseInt(e.target.value);
                    setForm({...form, welcome_bonus_images_registration: val});
                  }}
                  onFocus={(e) => {
                    if (e.target.value === '0') e.target.select();
                  }}
                  disabled={!editing}
                  className="w-full px-4 py-3 bg-black/60 border-2 border-emerald-500/30 rounded-xl text-emerald-400 text-lg font-bold text-center disabled:opacity-50 focus:border-emerald-400 transition-all"
                  placeholder="0"
                />
                <span className="text-sm text-emerald-400 whitespace-nowrap">Bilder</span>
              </div>
              <p className="text-xs text-white/40 mt-2">User bekommt Bilder direkt nach Registrierung</p>
            </div>

            <div className="p-4 bg-black/40 rounded-lg border border-yellow-500/20">
              <label className="text-sm font-bold text-white block mb-2">
                SNAPs bei Registrierung (sofort)
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  step="0.5"
                  min="0"
                  inputMode="decimal"
                  value={form.welcome_bonus_snaps_registration ?? ''}
                  onChange={(e) => {
                    const val = e.target.value === '' ? 0 : parseFloat(e.target.value);
                    setForm({...form, welcome_bonus_snaps_registration: val});
                  }}
                  onFocus={(e) => {
                    if (e.target.value === '0') e.target.select();
                  }}
                  disabled={!editing}
                  className="w-full px-4 py-3 bg-black/60 border-2 border-yellow-500/30 rounded-xl text-yellow-400 text-lg font-bold text-center disabled:opacity-50 focus:border-yellow-400 transition-all"
                  placeholder="0"
                />
                <span className="text-sm text-yellow-400 whitespace-nowrap">SNAPs</span>
              </div>
              <p className="text-xs text-white/40 mt-2">User bekommt SNAPs direkt nach Registrierung (z.B. 10 SNAPs = 10€ Guthaben)</p>
            </div>

            <div className="p-4 bg-black/40 rounded-lg border border-emerald-500/20">
              <label className="text-sm font-bold text-white block mb-2">
                Beim ersten Kauf (einmalig)
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  step="1"
                  min="0"
                  inputMode="numeric"
                  value={form.welcome_bonus_images_first_purchase ?? ''}
                  onChange={(e) => {
                    const val = e.target.value === '' ? 0 : parseInt(e.target.value);
                    setForm({...form, welcome_bonus_images_first_purchase: val});
                  }}
                  onFocus={(e) => {
                    if (e.target.value === '0') e.target.select();
                  }}
                  disabled={!editing}
                  className="w-full px-4 py-3 bg-black/60 border-2 border-emerald-500/30 rounded-xl text-emerald-400 text-lg font-bold text-center disabled:opacity-50 focus:border-emerald-400 transition-all"
                  placeholder="0"
                />
                <span className="text-sm text-emerald-400 whitespace-nowrap">Bilder</span>
              </div>
              <p className="text-xs text-white/40 mt-2">User bekommt Bilder beim ersten Kauf</p>
            </div>
          </div>
        </div>

        {/* BEREICH 1: EMPFEHLER-BONUS - STAFFEL-SYSTEM (BILDER) */}
        <div className="mb-8 p-6 bg-emerald-500/5 rounded-xl border border-emerald-500/20">
          <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
            <Users className="w-6 h-6 text-emerald-400" />
            Empfehler-Bonus: Staffel-System (Kostenlose Bilder)
          </h2>
          <p className="text-sm text-emerald-300/80 mb-6">
            Definiere Staffeln basierend auf dem Kaufbetrag. Die höchste passende Staffel wird verwendet.
          </p>
          
          {/* Staffeln */}
          <div className="space-y-3 mb-4">
            {(form.referrer_bonus_image_tiers || []).map((tier, index) => (
              <div key={index} className="p-4 bg-black/40 rounded-lg border border-emerald-500/20 flex items-center gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-emerald-500/20 rounded-full flex items-center justify-center">
                  <span className="text-emerald-400 font-bold text-sm">{index + 1}</span>
                </div>
                
                <div className="flex-1 grid grid-cols-1 md:grid-cols-4 gap-3">
                  <div>
                    <label className="text-xs text-white/60 block mb-1">Beschreibung</label>
                    <input
                      type="text"
                      value={tier.description || ''}
                      onChange={(e) => updateTier(index, 'description', e.target.value)}
                      disabled={!editing}
                      className="w-full px-3 py-2 bg-black/60 border border-emerald-500/30 rounded-lg text-white text-sm disabled:opacity-50"
                      placeholder="z.B. Starter"
                    />
                  </div>
                  
                  <div>
                    <label className="text-xs text-white/60 block mb-1">Min. €</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={tier.min_eur || ''}
                      onChange={(e) => updateTier(index, 'min_eur', e.target.value)}
                      disabled={!editing}
                      className="w-full px-3 py-2 bg-black/60 border border-emerald-500/30 rounded-lg text-white text-sm text-center disabled:opacity-50"
                      placeholder="10"
                    />
                  </div>
                  
                  <div>
                    <label className="text-xs text-white/60 block mb-1">Max. €</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={tier.max_eur || ''}
                      onChange={(e) => updateTier(index, 'max_eur', e.target.value)}
                      disabled={!editing}
                      className="w-full px-3 py-2 bg-black/60 border border-emerald-500/30 rounded-lg text-white text-sm text-center disabled:opacity-50"
                      placeholder="19.99"
                    />
                  </div>
                  
                  <div>
                    <label className="text-xs text-white/60 block mb-1">Bilder</label>
                    <input
                      type="number"
                      step="1"
                      min="0"
                      value={tier.images || ''}
                      onChange={(e) => updateTier(index, 'images', e.target.value)}
                      disabled={!editing}
                      className="w-full px-3 py-2 bg-black/60 border border-emerald-500/30 rounded-lg text-emerald-400 text-sm text-center font-bold disabled:opacity-50"
                      placeholder="5"
                    />
                  </div>
                </div>
                
                {editing && (
                  <button
                    onClick={() => deleteTier(index)}
                    className="flex-shrink-0 p-2 bg-red-500/10 border border-red-500/30 rounded-lg hover:bg-red-500/20 transition-colors"
                  >
                    <Trash2 className="w-5 h-5 text-red-400" />
                  </button>
                )}
              </div>
            ))}
          </div>
          
          {/* Add Tier Button */}
          {editing && (
            <button
              onClick={addTier}
              className="w-full py-3 px-4 bg-emerald-500/10 border border-emerald-500/30 rounded-lg text-emerald-400 font-semibold hover:bg-emerald-500/20 transition-all flex items-center justify-center gap-2"
            >
              <Plus className="w-5 h-5" />
              Neue Staffel hinzufügen
            </button>
          )}
          
          {!editing && (form.referrer_bonus_image_tiers || []).length === 0 && (
            <p className="text-center text-white/40 py-8">
              Keine Staffeln definiert. Klicke "Bearbeiten" um Staffeln hinzuzufügen.
            </p>
          )}
        </div>

        {/* Speichern & Abbrechen */}
        {editing && (
          <div className="flex justify-end gap-3">
            <button
              onClick={handleCancel}
              className="px-6 py-3 bg-white/10 text-white rounded-xl font-bold hover:bg-white/20 transition-all"
            >
              Abbrechen
            </button>
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-6 py-3 bg-[#10B981] text-black rounded-xl font-bold hover:bg-[#059669] transition-all disabled:opacity-50 flex items-center gap-2"
            >
              <Save className="w-4 h-4" />
              {saving ? 'Speichert...' : 'Bonus-Einstellungen speichern'}
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
